import React from 'react';
import { Image, Type } from '../../../Cloud.model';
import { SC_TooltipImagem } from './TooltipImagem.styled';

export type UHCTooltipImagemProps = {
    image: Image
}

export const UHCTooltipImagem: React.FC<UHCTooltipImagemProps> = ({ image }) => {
    const isShowAppName = (image.type === Type.APP)

    return (
        <SC_TooltipImagem>
            <p>Opção para servidor indisponível:</p>
            <p>
                {image.operationalSystem.name} {image.operationalSystem.arch} bits 
                {isShowAppName ? ` + ${image.application.name} ${image.application.version}` : null}
            </p>
        </SC_TooltipImagem>
    );
};
